<template>
    <div class="contact">
        <div class="title">联系我们</div>
        <div class="tips">期待为您提供专业的解决方案</div>
        <div class="boxes">
            <div class="box form-box">
                <div class="box-title">在线咨询</div>
                <el-form label-width="0px">
                    <el-form-item prop="name">
                        <el-input placeholder="您的姓名"></el-input>
                    </el-form-item>
                    <el-form-item prop="phone">
                        <el-input placeholder="联系电话"></el-input>
                    </el-form-item>
                    <el-form-item prop="email">
                        <el-input placeholder="电子邮箱"></el-input>
                    </el-form-item>
                    <el-form-item prop="message">
                        <el-input type="textarea" placeholder="留言内容" :rows="4"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="submit-btn">提交信息</div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="box info-box">
                <div class="box-title">联系方式</div>
                <div class="contact-item">
                    <img class="icon" src="../assets/image/location.webp">
                    <div class="contact-item-detail">
                        <div class="contact-item-label">公司地址</div>
                        <div class="contact-item-value">广东省佛山市南海区里水镇南海花博园农科路意美兰园对面</div>
                    </div>
                </div>
                <div class="contact-item">
                    <img class="icon" src="../assets/image/phone.webp">
                    <div class="contact-item-detail">
                        <div class="contact-item-label">联系电话</div>
                        <div class="contact-item-value">13556101918</div>
                    </div>
                </div>
                <div class="contact-item">
                    <img class="icon" src="../assets/image/email.webp">
                    <div class="contact-item-detail">
                        <div class="contact-item-label">电子邮箱</div>
                        <div class="contact-item-value">hxliot@qq.com</div>
                    </div>
                </div>
                <div class="contact-item">
                    <img class="icon" src="../assets/image/time.webp">
                    <div class="contact-item-detail">
                        <div class="contact-item-label">营业时间</div>
                        <div class="contact-item-value">周一至周日 9:00-18:00</div>
                    </div>
                </div>

            </div>
        </div>

        <img src="../assets/image/map.png" class="map vue-lazy">
    </div>
</template>

<script>
export default {
    name: 'ContactComp'
}
</script>

<style scoped lang="scss">
.contact {
    padding: 40px 20px 0;
    @media (min-width: 768px) {
        padding: 80px 80px 0;
    }
    box-sizing: border-box;
    width: 100%;
    background-color: #FFF;

    .title {
        color: #000000;
        font-family: "Inter";
        font-size: 24px;
        @media (min-width: 768px) {
            font-size: 30px;
        }
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 18px;
    }

    .tips {
        color: #4B5563;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 50px;
    }

    .boxes {
        display: flex;
        flex-direction: column;
        @media (min-width: 768px) {
            flex-direction: row;
            justify-content: space-between;
        }
        gap: 32px;
        width: 100%;

        .box {
            flex: 1;
            box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            min-height: 400px;
            padding: 32px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            gap: 16px;

            .box-title {
                color: #000000;
                font-family: "Inter";
                font-size: 20px;
                font-style: normal;
                font-weight: 600;
                line-height: 28px;
                margin-bottom: 24px;
            }

            .contact-item {
                display: flex;
                align-items: flex-start;
                gap: 16px;

                .icon {
                    width: 24px;
                    height: 24px;
                }

                .contact-item-detail {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    .contact-item-label {
                        color: #000000;
                        font-family: "Inter";
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 24px;
                    }

                    .contact-item-value {
                        color: #4B5563;
                        font-family: "Inter";
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                    }
                }
            }

            .submit-btn {
                width: 100%;
                background: #2A5BDA;
                border-radius: 8px;
                color: #FFFFFF;
                font-family: "Inter";
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px;
                text-align: center;
                padding: 12px 0;
                cursor: pointer;
            }
        }
    }

    .box {
        :deep(.el-input__wrapper), :deep(.el-textarea__inner) {
            padding: 8px 16px;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }
    }

    .map {
        margin: 30px 0 0;
        width: 100%;
        max-width: 100%;
        height: auto;
        box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
    }

}
</style>